import React, { Component } from 'react';
import { Menu, Dropdown } from 'antd';
import map from 'lodash.map';
import find from 'lodash.find';
import './EnvSwitchDropdown.css';
import PropTypes from 'prop-types';
import config from 'config';

export default class EnvSwitchDropdown extends Component {

  static propTypes = {
    clickFunction: PropTypes.func
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  componentWillMount() {
    const currentEnvUrl = localStorage.getItem('envBaseUrl') || process.env.BASE_URL;
    console.log(`env = ${ currentEnvUrl }`);
  }

  render() {
    const menu = (
      <Menu>
        {
          map(config.envsArray, i => (
            <Menu.Item key={ i.url }>
              <a onClick={ () => this.props.clickFunction(i.url) } className="env-anchor">
                <img className="logo-img" src={ i.logo } />{ i.name }</a>
            </Menu.Item>))
        }
      </Menu>
    );

    const currentEnvUrl = localStorage.getItem('envBaseUrl') || process.env.BASE_URL;
    console.table(config.envsArray);

    const currentEnv = find(config.envsArray, ['url', currentEnvUrl]);

    if (!currentEnv) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('suAccessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      localStorage.removeItem('admin');
      window.location.href = '/login';
    }

    return (
      <Dropdown overlay={ menu } className="env-dropdown" trigger={ ['click'] }>
        <a className="ant-dropdown-link env-anchor">
          <img className="logo-img" src={ currentEnv.logo } />
          { currentEnv.name }
        </a>
      </Dropdown>
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/env-switch-dropdown/EnvSwitchDropdown.jsx